export default __webpack_public_path__ + "static/media/icons-number.fefc4ebb.svg";